import Icon from '../components/Icon.vue'

Icon.register({"tablet-alt":{"width":448,"height":512,"paths":[{"d":"M400 0H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V48C448 21.5 426.5 0 400 0zM224 480C206.3 480 192 465.7 192 448S206.3 416 224 416 256 430.3 256 448 241.7 480 224 480zM400 372C400 378.6 394.6 384 388 384H60C53.4 384 48 378.6 48 372V60C48 53.4 53.4 48 60 48H388C394.6 48 400 53.4 400 60V372z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tablet-alt.js
// module id = aTCU
// module chunks = 0